// extracted by mini-css-extract-plugin
module.exports = {"paymentMethodLogo":"paymentForm_paymentMethodLogo__3yj6j","fitContent":"paymentForm_fitContent__tvviE"};